<template>
  <modal @close="modals.fulfilmentExportModal = false">
      <h3>Fulfilment History Export</h3>
      <div class="large-form">            
          <div class="form-line">
              <div class="form-field form-field-radio" >
                  <label>CSV History Export Method</label>
                  <div class="radio-option">
                    <input v-model="item.exportMethod" type="radio" value="date-range">
                    <span class="radio-label">Date Range</span>
                  </div>
                  
                  <div class="radio-option">
                    <input v-model="item.exportMethod" type="radio" value="id-range">
                    <span class="radio-label">Order ID Range</span>
                  </div>
              </div>
              
              <div class="form-line" v-if="item.exportMethod==='date-range'">
                  <div class="form-field"  style="width: 50%">
                      <label>Starting Date</label>
                      <input type="date" v-model="item.dateStart">
                  </div>
                  <div class="form-field"  style="width: 50%">
                      <label>Ending Date</label>
                      <input type="date" v-model="item.dateEnd">
                  </div>
              </div>
              
              <div class="form-line" v-if="item.exportMethod==='id-range'">
                  <div class="form-field"  style="width: 50%">
                      <label>Starting Order ID</label>
                      <input type="number" v-model="item.idStart">
                  </div>
                  <div class="form-field"  style="width: 50%">
                      <label>Ending Order ID</label>
                      <input type="number" v-model="item.idEnd">
                  </div>
              </div>
              
          </div>
          <div class="modal-errors">
              <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
          </div>
      </div>
      <div class="form-actions">
          <span class="ws-button ws-button-main" @click="exportHistory()">GENERATE CSV EXPORT</span>
          <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.fulfilmentExportModal = false">GO BACK</span>
      </div>
  </modal>
</template>


<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "FulfilmentExportModal",
    components: {Modal},
    props: ['lastId',],
    data() {
        return {
            item: {
              exportMethod: 'date-range', dateStart: null, dateEnd: null, idStart: 0, idEnd: 0,
            },
            exportParams: {},
            errors: {},
        }
    },
    methods: {
      setDefaults() {
        const now = new Date();
        const monthAgo = new Date();
        monthAgo.setMonth(monthAgo.getMonth() - 1);
        this.item.dateStart = monthAgo.toISOString().split('T')[0];
        this.item.dateEnd = now.toISOString().split('T')[0];
        this.item.idStart = 1;
        this.item.idEnd = this.lastId;
      },
      async exportHistory() {
          if (this.item.exportMethod === 'date-range') this.exportParams = {
                'date-start': this.item.dateStart,
                'date-end': this.item.dateEnd
            };
          else this.exportParams = {
                'id-start': this.item.idStart,
                'id-end': this.item.idEnd
            };
          
          const csvContent = await this.dispatchWaitAndNotify('exportFulfilmentHistory', this.exportParams);
          let link = document.createElement("a");
          let csvData = new Blob([csvContent], { type: 'text/csv' });
          link.setAttribute("href", URL.createObjectURL(csvData));
          link.setAttribute("download", this.csvFileName);
          document.body.appendChild(link); 
          link.click();
          link.remove();
      }
    },
    async mounted() {
        this.setDefaults();
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
        restApiNonce() {
            return window.restApiNonce;
        },
        csvFileName() {
          if (this.item.exportMethod === 'date-range') return 'ws-fulfilment-'+this.item.dateStart+'-to-'+this.item.dateEnd+'.csv';     
          else return 'ws-fulfilment-ids-'+this.item.idStart+'-to-'+this.item.idEnd+'.csv';     
        },
    }
}
</script>

<style scoped>

</style>